import React from 'react'
import { Link } from 'react-router-dom'

const TeamPlayerDetail = () => {
    return (
        <>
            <div className="page-wrapper">
                <div className="page-content">
                    <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Teams Management</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">Team Player Detail</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <hr />
                    <div className="detail_top_pgg">
                        <Link to="/team-management-detail"><i className="bx bx-arrow-back" /><span>Back</span></Link>
                    </div>
                    <div className="card personal_d">
                        <div className="card-body">
                            <h2>Personal Details</h2>
                            <div className="row">
                                <div className="col-lg-2">
                                    <div className="d-flex flex-column align-items-center text-center">
                                        <img src="images/player/p1.jpg" alt="Admin" className="p-1 bg-primary" style={{ width: 200, height: 200, objectFit: 'cover', borderRadius: '50%' }} />
                                    </div>
                                </div>
                                <div className="col-lg-5">
                                    <div className="inp_grp">
                                        <label>Name</label>
                                        <input type="text" className="form-control" defaultValue="Player One" readOnly />
                                    </div>
                                    <div className="inp_grp">
                                        <label>Jersey Number</label>
                                        <input type="text" className="form-control" defaultValue="#10" readOnly />
                                    </div>
                                    <div className="inp_grp">
                                        <label>Matches Played</label>
                                        <input type="text" className="form-control" defaultValue={25} readOnly />
                                    </div>
                                    <div className="inp_grp">
                                        <label>Assists</label>
                                        <input type="text" className="form-control" defaultValue={8} readOnly />
                                    </div>
                                </div>
                                <div className="col-lg-5">
                                    <div className="inp_grp">
                                        <label>Date of Birth</label>
                                        <input type="text" className="form-control" defaultValue="2010-05-15" readOnly />
                                    </div>
                                    <div className="inp_grp">
                                        <label>Team</label>
                                        <input type="text" className="form-control" defaultValue="Eagles FC" readOnly />
                                    </div>
                                    <div className="inp_grp">
                                        <label>Goals</label>
                                        <input type="text" className="form-control" defaultValue={12} readOnly />
                                    </div>
                                    <div className="inp_grp">
                                        <label>Position</label>
                                        <input type="text" className="form-control" defaultValue="Forward" readOnly />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card personal_d">
                        <div className="card-body">
                            <h2>Parent/Guardian Info</h2>
                            <div className="row">
                                <div className="col-lg-3">
                                    <div className="inp_grp">
                                        <label>Name</label>
                                        <input type="text" className="form-control" defaultValue="Parent Name" readOnly />
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <div className="inp_grp">
                                        <label>Email Address</label>
                                        <input type="text" className="form-control" defaultValue="parent@email.com" readOnly />
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <div className="inp_grp">
                                        <label>Phone Number</label>
                                        <input type="text" className="form-control" defaultValue="+1 (555) 123-4567" readOnly />
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <div className="inp_grp">
                                        <label>Relationship</label>
                                        <input type="text" className="form-control" defaultValue="Father" readOnly />
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <div className="inp_grp">
                                        <label>Emergency Contact</label>
                                        <input type="text" className="form-control" defaultValue="+1 (555) 123-4567" readOnly />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default TeamPlayerDetail